export const INPAINT_MODELS = {
  'komiyama/inpaint-y10:rev0': 'Hikari',
  'komiyama/inpaint-wf:rev0': 'Waterfront',
}
